"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsigInvalidArgumentError = exports.StatsigUninitializedError = void 0;
class StatsigUninitializedError extends Error {
    constructor(message) {
        super(message !== null && message !== void 0 ? message : 'Call and wait for initialize() to finish first.');
    }
}
exports.StatsigUninitializedError = StatsigUninitializedError;
class StatsigInvalidArgumentError extends Error {
}
exports.StatsigInvalidArgumentError = StatsigInvalidArgumentError;
